// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"3fcbcf76","178":"7a301882","265":"9948d8e2","377":"c6efd445","380":"dd96aa23","425":"3313cab9","454":"5636d840","578":"06cef56e","596":"157c4a89","843":"e6cbf29a","856":"1c4de54c","921":"27f51db0"}[chunkId] + ".chunk.js";
};